import React, { useEffect, useRef, useState } from "react";
import iconeAdd from "../../../../assets/IconeSvg/boutonAdd.svg";
import iconethreeDots from "../../../../assets/IconeSvg/treeDotsGray.svg";
import iconeDelete from "../../../../assets/IconeSvg/delete.svg";
import iconePencil from "../../../../assets/IconeSvg/pencil.svg";
import iconeCloseWindow from "../../../../assets/IconeSvg/close_window.svg";
import iconeAppareilPhoto from "../../../../assets/IconeSvg/appareil_photo.svg";
import iconeSearch from "../../../../assets/IconeSvg/search.svg";
import { Drawer, Pagination, Snackbar } from "@mui/material";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import {
  enregistrerCategories,
  listeDesCategories,
  modifierCategorieById,
  supprimerUneCategorie
} from "../../../../services/parametrage/CategorieRequest";
import fr from "date-fns/locale/fr";

function formatDateToFrench(dateString) {
  const date = new Date(dateString);

  // Options for the French date format
  const options = {
    day: "2-digit",
    month: "long",
    year: "numeric"
  };

  // Format the date to French locale
  return date.toLocaleDateString("fr-FR", options);
}

const Categories = () => {
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 10,
    nombrePage: 1,
    pagePagination: 1
  });

  const fileInputRef = useRef(null);
  const fileInputRef2 = useRef(null);
  const [preview, setPreview] = useState(null);
  const [preview2, setPreview2] = useState(null);
  const [filePhoto, setFilePhoto] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [file, setFile] = useState(null);
  const [imageBamniere, setImageBamniere] = useState("");

  const [addLoading, setAddLoading] = useState(false);
  const [loadingActivation, setLoadingActivation] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);

  const [listeAllCategories, setListeAllCategories] = useState([]);
  const [searchParam, setSearchParam] = useState("");
  const [designation, setDesignation] = useState("");
  const [description, setDescription] = useState("");
  const [dateDebut, setDateDebut] = useState(new Date());
  const [dateFin, setDateFin] = useState(new Date());
  const [categorieInfos, setCategorieInfos] = useState(null);

  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center"
  });
  const { vertical, horizontal } = snackbarPosition;

  // Upload photo de profil
  const handleClick = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFilePhoto(file);
      console.log("nouvelle image :", file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreview(e.target.result);
      };

      console.log(preview);
      reader.readAsDataURL(file);
    }
  };

  // Upload photo de profil
  const handleClickBanniere = () => {
    if (selectedFiles.length === 5) {
      setErrorMessage(
        "Désolé vous avez atteind le nombre d'image requis. Retirer pour en ajouter de"
      );
      setSnackbarOpenError(true);
      return;
    }

    fileInputRef2.current.click();
  };
  const removeImage = (index) => {
    const newFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(newFiles);
    setFile(newFiles);

    // Cas où il reste au moins une image
    if (newFiles.length > 0) {
      const first = newFiles[0];

      if (first instanceof Blob) {
        // Si c’est un File/Blob, on en crée la preview en base64
        const reader = new FileReader();
        reader.onload = (e) => setPreview2(e.target.result);
        reader.readAsDataURL(first);
      } else if (typeof first === "string") {
        // Si c’est une URL (string), on l’affecte directement
        setPreview2(first);
      }
    } else {
      // Plus d’images → on reset la preview
      setPreview2(null);
    }

    setImageBamniere(newFiles);
  };
  const handleFileChangeBanniere = (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    const remainingSlots = 5 - selectedFiles.length;
    const newFiles = files.slice(0, remainingSlots);
    const updatedFiles = [...selectedFiles, ...newFiles].slice(0, 5);

    setSelectedFiles(updatedFiles);
    setFile(updatedFiles);
    setImageBamniere(updatedFiles);

    // Preview de la première image ou URL
    const first = updatedFiles[0];
    if (first instanceof Blob) {
      // Seulement un Blob/File → lecture via FileReader
      const reader = new FileReader();
      reader.onload = (e) => setPreview2(e.target.result);
      reader.readAsDataURL(first); // OK si Blob :contentReference[oaicite:5]{index=5}
    } else if (typeof first === "string") {
      // URL existante → attribution directe
      setPreview2(first);
    }
  };

  const TableElement = ({ categorieItem }) => {
    return (
      <tr className=" bg-white">
        <td className="px-4 truncate text-sm text-stone-500 font-medium">
          <img
            src={categorieItem.image ? categorieItem.image : "-"}
            alt=""
            className="w-10 h-10"
          />
        </td>
        <td className="px-4 truncate text-sm text-stone-500 font-medium">
          {categorieItem.nom ? categorieItem.nom : "-"}
        </td>
        <td className="px-4 truncate text-sm text-stone-500 font-medium">
          {categorieItem.description ? categorieItem.description : "-"}
        </td>

        <td className="px-4">
          <div className="dropdown dropdown-left dropdown-end">
            <div
              tabIndex={0}
              className="w-7 h-7 rounded-lg bg-gray-200 flex items-center justify-center cursor-pointer"
            >
              <img src={iconethreeDots} alt="" />
            </div>
            <ul
              tabIndex={0}
              className="dropdown-content z-50 menu p-1 shadow border bg-white rounded-lg w-32 mr-2"
            >
              <button
                onClick={() => {
                  setCategorieInfos(categorieItem);
                  openModalModif(categorieItem);
                }}
                className="w-full h-9 px-2 hover:bg-zinc-100 flex gap-x-1 items-center justify-start rounded-md"
              >
                <img src={iconePencil} alt="" className="w-5" />
                <span className="font-semibold text-sm">Modifier</span>
              </button>

              <button
                onClick={() => {
                  setCategorieInfos(categorieItem);
                  document.getElementById("detele_categorie").showModal();
                }}
                className="w-full h-9 px-2 hover:bg-zinc-100 flex gap-x-1 items-center justify-start rounded-md"
              >
                <img src={iconeDelete} alt="" className="w-5" />
                <span className="font-semibold text-sm">Supprimer</span>
              </button>
            </ul>
          </div>
        </td>
      </tr>
    );
  };

  const openModalModif = (categorieItem) => {
    setOpenModal(true);
    setCategorieInfos(categorieItem);
    setDesignation(categorieItem.nom);
    setDescription(categorieItem.description);
    setFilePhoto(categorieItem.image);
    setSelectedFiles(categorieItem.imageBannieres);
  };

  // === VIDE FORMULAIRE ===
  const clearFormEnregistrement = () => {
    setCategorieInfos(null);
    setAddLoading(false);
    setDesignation("");
    setDescription("");
  };

  // === RECUPERE LISTE DES CATEGORIES ===
  const getListeDesCategories = () => {
    setLoadingData(true);
    // pageQuery.page, pageQuery.size, ""
    listeDesCategories(pageQuery.page, pageQuery.size, "")
      .then((res) => {
        setLoadingData(false);
        console.log(res);
        setListeAllCategories(res.data.categories);
        setPageQuery({
          ...pageQuery,
          nombrePage: res.data.totalPages
        });
      })
      .catch((error) => {
        setLoadingData(false);
        console.log("error recontrer ===== :", error);
      });
  };

  // === ENREGISTRE UNE CATEGORIE ===
  const handleCategorie = () => {
    setAddLoading(true);
    const dataCategorie = new FormData();
    dataCategorie.append("nom", designation);
    dataCategorie.append("description", description);

    if (filePhoto) {
      dataCategorie.append("images", filePhoto);
    }
    // plusieurs bannières : on boucle
    imageBamniere.forEach((file) => {
      dataCategorie.append("imageBannieres", file);
    });

    enregistrerCategories(dataCategorie)
      .then((res) => {
        clearFormEnregistrement();
        setAddLoading(false);
        setOpenModal(false);
        setSuccessMessage("Catégorie enregistréee avec succès.");
        setSnackbarOpenSuccess(true);
        getListeDesCategories();
        setDesignation("");
        setDescription("");
        setFilePhoto("");
        setPreview(null);
        setPreview2(null);
      })
      .catch((err) => {
        setAddLoading(false);
        if (err && err.response) {
          if (err.response.status === 400) {
            setErrorMessage(
              `Erreur ${err.response.status} des informations manquantes`
            );
            setSnackbarOpenError(true);
          } else {
            setErrorMessage(
              `Erreur ${err.message} des informations manquantes`
            );
            setSnackbarOpenError(true);
          }
        } else {
          setErrorMessage("Erreur d'enregistrement, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("ELEMENT", err);
      });
  };

  // === MODIFIER UNE CATEGORIE ===
  const modifierCategorie = () => {
    setAddLoading(true);

    const dataCategorie = new FormData();
    dataCategorie.append("nom", designation);
    dataCategorie.append("description", description);
    dataCategorie.append("image", filePhoto ? filePhoto : categorieInfos.image);
    // bannières : soit les nouvelles images, soit les anciennes URLs
  if (imageBamniere.length > 0) {
    imageBamniere.forEach(file => {
      dataCategorie.append("imageBannieres", file);
    });
  } else if (categorieInfos.imageBannieres?.length) {
    categorieInfos.imageBannieres.forEach(url => {
      dataCategorie.append("imageBannieres", url);
    });
  }
    

    modifierCategorieById(categorieInfos._id, dataCategorie)
      .then((res) => {
        clearFormEnregistrement();
        setAddLoading(false);
        setOpenModal(false);
        setPreview(null);
        setPreview2(null);
        setSuccessMessage("Catégorie modifiée avec succès.");
        setSnackbarOpenSuccess(true);
        getListeDesCategories();
      })
      .catch((err) => {
        setAddLoading(false);
        if (err && err.response && err.response.data) {
          setErrorMessage(err.response.data.message);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Erreur d'enregistrement, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("ELEMENT", err);
      });
  };

  // === RENDRE ANNÉE ACTIVE ===
  // const modifierEtatDeAnneeScolaire = () => {
  //   setLoadingActivation(true);
  //   rendreAnneeActive(categorieInfos._id)
  //     .then((res) => {
  //       setLoadingActivation(false);
  //       setSuccessMessage("Année catéchétique activée avec succès.");
  //       setSnackbarOpenSuccess(true);
  //       getListeDesAnneesCatechumique();
  //       document.getElementById("annee_active").close();
  //     })
  //     .catch((err) => {
  //       setLoadingActivation(false);
  //       if (err && err.response && err.response.data) {
  //         setErrorMessage(err.response.data.message);
  //         setSnackbarOpenError(true);
  //       } else {
  //         setErrorMessage("Erreur d'enregistrement, rééssayer!");
  //         setSnackbarOpenError(true);
  //       }
  //       console.log("ELEMENT", err);
  //     });
  // };

  // === SUPPRIMER CATEGORIE ===
  const supprimerAnneeCatechumique = () => {
    setDeleteLoading(true);

    supprimerUneCategorie(categorieInfos._id)
      .then((res) => {
        setSuccessMessage("Catégorie supprimée avec succès");
        getListeDesCategories();
        setSnackbarOpenSuccess(true);
        setDeleteLoading(false);
        document.getElementById("detele_categorie").close();
      })
      .catch((err) => {
        setDeleteLoading(false);
        if (err && err.response && err.response.data) {
          setErrorMessage(err.response.data.message);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Une erreur s'est produite, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  // === FILTRER LES ELEMENTS ===
  const filterElement = () => {
    setSearchLoading(true);

    listeDesCategories(pageQuery.page, pageQuery.size, searchParam)
      .then((res) => {
        setSearchLoading(false);
        setListeAllCategories(res.data.categories);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.totalPages,
          totalElements: res.data.totalElements
        }));
      })
      .catch((error) => {
        setSearchLoading(false);
        console.log("error", error);
      });
  };

  // === PAGINATION DES ELEMENTS ===
  const handlePaginationChange = (event, value) => {
    setLoadingData(true);
    setPageQuery((prev) => ({
      ...prev,
      page: value,
      pagePagination: value
    }));
    // listeDesAnneesCatechumiquePaginee(value, pageQuery.size, searchParam)
    listeDesCategories(value, pageQuery.size, searchParam)
      .then((res) => {
        setLoadingData(false);
        setListeAllCategories(res.data.categories);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.totalPages,
          totalElements: res.data.totalCategories
        }));
      })
      .catch((error) => {
        setLoadingData(false);
        console.log("error", error);
      });
  };

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  useEffect(() => {
    getListeDesCategories();
  }, []);

  return (
    <div className="w-full h-full">
      <div className="flex flex-col sm:flex-row justify-end items-end sm:items-center gap-2">
        <div className="w-full sm:w-fit flex items-center gap-x-2">
          <input
            type="text"
            placeholder="Rechercher un élement..."
            value={searchParam}
            onChange={(e) => setSearchParam(e.target.value)}
            className="input input-bordered w-11/12 sm:w-56 h-10 text-sm font-medium"
          />
          <button
            disabled={searchLoading}
            className="bg-gray-600 text-sm text-white h-10 w-fit px-4 font-semibold rounded-xl flex items-center justify-center"
            onClick={filterElement}
          >
            {!searchLoading ? (
              "Rechercher"
            ) : (
              <ThreeDots
                height="35"
                width="35"
                radius="9"
                color="#fff"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={searchLoading}
              />
            )}
          </button>
        </div>
        <button
          onClick={() => {
            clearFormEnregistrement();
            setOpenModal(true);
          }}
          className="bg-primary w-full sm:w-fit h-10 px-4 flex items-center justify-center gap-x-2 rounded-xl"
        >
          <img src={iconeAdd} alt="" className="w-5 sm:w-auto" />
          <span className="text-white text-sm font-semibold truncate">
            Ajouter une catégorie
          </span>
        </button>
      </div>

      <div className="mt-2 w-full h-full">
        <div className="overflow-x-auto">
          <table className="custom-table table table-zebra w-full">
            <thead>
              <tr className="bg-black h-12">
                <th className="text-sm text-white">Image</th>
                <th className="text-sm text-white">Désignation</th>
                <th className="text-sm text-white">Description</th>
                <th className="text-sm text-white">Action</th>
              </tr>
            </thead>
            <tbody>
              {!loadingData && listeAllCategories.length > 0 ? (
                listeAllCategories.map((item) => (
                  <TableElement key={item._id} categorieItem={item} />
                ))
              ) : !loadingData && listeAllCategories.length === 0 ? (
                <tr>
                  <td colSpan="7">
                    <div className="w-full h-32 bg-white flex gap-x-2 text-red-500 items-center justify-center">
                      <p className="font-semibold text-lg text-red-600">
                        Aucun élément trouvé
                      </p>
                    </div>
                  </td>
                </tr>
              ) : loadingData && listeAllCategories.length === 0 ? (
                <tr>
                  <td colSpan="7">
                    <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                      <TailSpin
                        height="30"
                        width="30"
                        color="#000"
                        ariaLabel="tail-spin-loading"
                        radius="1"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={loadingData}
                      />
                    </div>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan="7">
                    <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                      <TailSpin
                        height="30"
                        width="30"
                        color="#000"
                        ariaLabel="tail-spin-loading"
                        radius="1"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={loadingData}
                      />
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="flex justify-end mt-2">
          <Pagination
            count={pageQuery.nombrePage}
            page={pageQuery.pagePagination}
            variant="outlined"
            shape="rounded"
            onChange={handlePaginationChange}
          />
        </div>
      </div>

      <Drawer
        anchor={"right"}
        open={openModal}
        onClose={() => setOpenModal(false)}
      >
        <div className="w-full sm:w-[430px] p-4 flex flex-col bg-white h-full">
          <div className="flex flex-row  justify-start items-center gap-3 mb-6">
            <button onClick={() => setOpenModal(false)}>
              <img src={iconeCloseWindow} alt="" />
            </button>

            <h2 className=" text-xl font-extrabold">
              {categorieInfos === null
                ? " Ajouter une catégorie"
                : "Modifier cette catégorie"}
            </h2>
          </div>

          <div className="flex justify-center items-center  my-[1rem] w-full ">
            <div
              onClick={handleClick}
              className="flex justify-center items-center w-40 h-40 bg-[#F9F9F9] rounded-full cursor-pointer"
            >
              {preview &&
              (categorieInfos !== null || categorieInfos === null) ? (
                <div className="relative ">
                  <div className="absolute bg-[#0000009a]  w-40 h-40 rounded-full flex justify-center">
                    <img src={iconeAppareilPhoto} className="w-8" alt="" />
                  </div>
                  <img
                    src={preview}
                    alt="Preview"
                    className="w-40 h-40 rounded-full"
                  />
                </div>
              ) : preview === null && categorieInfos !== null ? (
                <div className="relative">
                  <div className="absolute bg-[#00000079]  w-40 h-40 rounded-full flex justify-center">
                    <img src={iconeAppareilPhoto} className="w-8" alt="" />
                  </div>
                  <img
                    src={categorieInfos && categorieInfos.image}
                    alt=""
                    className="w-40 h-40 rounded-full"
                  />
                </div>
              ) : (
                <div className="w-20 h-20 rounded-full flex justify-center">
                  <img src={iconeAppareilPhoto} className="w-8" alt="" />
                </div>
              )}
            </div>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </div>

          <div className="flex flex-col justify-center items-center ">
            {/* Liste des vignettes */}
            {selectedFiles && selectedFiles.length > 0 ? (
              <>
                <button
                  onClick={handleClickBanniere}
                  className="flex justify-center items-center  py-1 px-4  bg-[#f3f3f3] rounded-lg cursor-pointer"
                >
                  <img src={iconeAppareilPhoto} className="w-8" alt="" />
                  <span className="text-[12px] font-medium">
                    Ajouter d'autres photo de couverture
                  </span>
                </button>
                <div className="w-full mt-4 space-y-2">
                  {selectedFiles?.map((file, index) => (
                    <div
                      key={index}
                      className="relative flex items-center justify-between border-[2px] rounded-lg px-4 py-1"
                    >
                      <img
                        src={
                          file instanceof Blob
                            ? URL.createObjectURL(file)
                            : file // pour les chaînes d’URL existantes
                        }
                        alt={`Preview ${index + 1}`}
                        className="h-36 w-full object-contain"
                      />
                      <button
                        type="button"
                        onClick={() => removeImage(index)}
                        className=" text-red-500 font-semibold cursor-pointer bg-red-100 py-1 px-2 rounded-lg hover:text-red-700"
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div
                  onClick={handleClickBanniere}
                  className="flex justify-center items-center w-full h-40 bg-[#f3f3f3] rounded-md cursor-pointer"
                >
                  <div className="w-full h-64  flex flex-col justify-center items-center">
                    <img src={iconeAppareilPhoto} className="w-8" alt="" />
                    <span className="text-[12px] mt-4 font-medium">
                      Sélectionner vos photo de couverture
                    </span>
                  </div>
                </div>
                <h2 className="text-[12px] italic font-semibold text-red-600 mt-2">
                  Maximum 5 photo de couverture autorisées
                </h2>
              </>
            )}

            <input
              type="file"
              multiple
              ref={fileInputRef2}
              style={{ display: "none" }}
              onChange={handleFileChangeBanniere}
              accept="image/*"
            />
          </div>

          <div className="mt-6">
            <div>
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text font-bold text-gray-500 text-sm">
                    Désignation
                  </span>
                </div>
                <input
                  type="text"
                  value={designation}
                  onChange={(e) => setDesignation(e.target.value)}
                  disabled={addLoading}
                  placeholder="Entrer le nom"
                  className="input input-bordered w-full h-10 font-medium bg-[#F9F9F9]"
                />
              </label>
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text font-bold text-gray-500 text-sm">
                    description
                  </span>
                </div>
                <input
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  disabled={addLoading}
                  placeholder="Entrer le nom"
                  className="input input-bordered w-full h-10 font-medium bg-[#F9F9F9]"
                />
              </label>
            </div>

            <button
              onClick={
                categorieInfos === null
                  ? () => handleCategorie()
                  : () => modifierCategorie()
              }
              disabled={addLoading}
              className="mt-8 bg-primary flex items-center justify-center w-full h-11 font-bold text-white rounded-lg hover:drop-shadow-md"
            >
              {!addLoading ? (
                <span>
                  {categorieInfos === null ? "Enregistrer" : "Modifier"}
                </span>
              ) : (
                <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={addLoading}
                />
              )}
            </button>
          </div>
        </div>
      </Drawer>

      {/* MODAL DELETE ENTREPRISE */}
      <dialog id="annee_active" className="modal">
        <div className="modal-box rounded-lg">
          <form method="dialog">
            <button className="w-7 h-7 absolute right-2 top-2">
              <img
                onClick={() => setCategorieInfos(null)}
                src={iconeCloseWindow}
                className="cursor-pointer w-full"
                alt=""
              />
            </button>
          </form>
          <h3 className="font-extrabold text-xl text-center text-green-600">
            Modifier année catéchumique en cours
          </h3>
          <div className="pt-4 pb-2">
            <p className="text-center text-base font-medium text-gray-600">
              Attention cette action rendra cette année catéchumique active pour
              toutes les opérations effectuées dans l'application.
            </p>
          </div>
          <div className="modal-action flex justify-center">
            <form
              method="dialog"
              className="w-full flex flex-col sm:flex-row justify-center gap-x-3"
            >
              {/* if there is a button in form, it will close the modal */}
              {loadingActivation ? (
                <div
                  disabled={loadingActivation}
                  className="w-full sm:w-32 h-10 bg-gray-300 text-gray-700 text-sm rounded-lg flex items-center justify-center font-semibold"
                >
                  Annuler
                </div>
              ) : (
                <button
                  disabled={loadingActivation}
                  className="w-full sm:w-32 h-10 bg-gray-300 text-gray-700 text-sm rounded-lg flex items-center justify-center font-semibold"
                >
                  Annuler
                </button>
              )}
              <div
                // onClick={modifierEtatDeAnneeScolaire}
                disabled={loadingActivation}
                className="mt-2 sm:mt-0 w-full sm:w-56 px-2 h-10 bg-green-600 text-white text-sm rounded-lg flex items-center justify-center font-semibold cursor-pointer"
              >
                {!loadingActivation ? (
                  "Rendre active"
                ) : (
                  <ThreeDots
                    height="40"
                    width="40"
                    radius="9"
                    color="#fff"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={loadingActivation}
                  />
                )}
              </div>
            </form>
          </div>
        </div>
      </dialog>

      {/* MODAL DELETE CATEGORIE   */}
      <dialog id="detele_categorie" className="modal">
        <div className="modal-box rounded-lg">
          <form method="dialog">
            <button className="w-7 h-7 absolute right-2 top-2">
              <img
                onClick={() => setOpenModal(false)}
                src={iconeCloseWindow}
                className="cursor-pointer w-full"
                alt=""
              />
            </button>
          </form>
          <h3 className="font-extrabold text-xl text-center text-primary">
            Supprimer cette catégorie
          </h3>
          <div className="pt-4 pb-2">
            <p className="text-center text-base font-medium text-gray-600">
              Attention action est irrversible et entrainera la suppression de
              cette catégorie
            </p>
          </div>
          <div className="modal-action flex justify-center">
            <form
              method="dialog"
              className="w-full flex flex-col sm:flex-row justify-center gap-x-3"
            >
              {/* if there is a button in form, it will close the modal */}
              {deleteLoading ? (
                <div
                  disabled={deleteLoading}
                  className="w-full sm:w-32 h-10 bg-gray-300 text-gray-700 text-sm rounded-lg flex items-center justify-center font-semibold"
                >
                  Annuler
                </div>
              ) : (
                <button
                  disabled={deleteLoading}
                  className="w-full sm:w-32 h-10 bg-gray-300 text-gray-700 text-sm rounded-lg flex items-center justify-center font-semibold"
                >
                  Annuler
                </button>
              )}
              <div
                onClick={supprimerAnneeCatechumique}
                disabled={deleteLoading}
                className="mt-2 sm:mt-0 w-full sm:w-56 px-2 h-10 bg-primary text-white text-sm rounded-lg flex items-center justify-center font-semibold cursor-pointer"
              >
                {!deleteLoading ? (
                  "Supprimer quand même"
                ) : (
                  <ThreeDots
                    height="40"
                    width="40"
                    radius="9"
                    color="#fff"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={deleteLoading}
                  />
                )}
              </div>
            </form>
          </div>
        </div>
      </dialog>

      {/* SNACKBAR SUCCESS */}
      {successMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarSuccessOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarSuccess}
          key={vertical + horizontal}
          className="z-[999999]"
        >
          <div className="bg-green-500 text-white font-semibold z-[999999] px-10 py-3 rounded-lg">
            {successMessage}
          </div>
        </Snackbar>
      ) : null}

      {/* SNACKBAR ERROR */}
      {errorMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarErrorOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarError}
          key={vertical + horizontal}
          className="z-[999999]"
        >
          <div className="bg-red-500 text-white font-semibold z-[999999] px-10 py-3 rounded-lg">
            {errorMessage}
          </div>
        </Snackbar>
      ) : null}
    </div>
  );
};

export default Categories;
